/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getList(params = {}) {
    return axios.get(this.url, { params });
  }

  getReport(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/report`, { params });
  }

  downloadReport(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/download`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new CampaignsAPI();
